import { chain, find, head, pipe, prop, propEq, replace } from 'ramda';
import { MediaManagerSDKPublicMediaFolder } from '../../hoc/withPublicMedia/withPublicMedia.types';

export const readCookie = (name) => {
  const processedName = replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1', name);

  const regex = new RegExp(`(?:^|;)\\s?${processedName}=(.*?)(?:;|$)`, 'i');
  const match = document.cookie.match(regex);

  return match && unescape(match[1]);
};

export const getSubFoldersOfFirstItem = pipe<
  MediaManagerSDKPublicMediaFolder[],
  MediaManagerSDKPublicMediaFolder,
  MediaManagerSDKPublicMediaFolder[]
>(head, prop('subFolders'));

export const getIdOfFirstItem = pipe<MediaManagerSDKPublicMediaFolder[], MediaManagerSDKPublicMediaFolder, string>(
  head,
  prop('id'),
);

export const findCategoryBySubCategoryId = (subCategoryId, categories) => () =>
  pipe<MediaManagerSDKPublicMediaFolder[], MediaManagerSDKPublicMediaFolder[], MediaManagerSDKPublicMediaFolder>(
    chain(prop('subFolders')),
    find(pipe(prop('subFolders'), head, propEq('id', subCategoryId))),
  )(categories);

export const getCategoryProperty = (propName, childCategoryId, categories) =>
  pipe<MediaManagerSDKPublicMediaFolder[], MediaManagerSDKPublicMediaFolder, string>(
    findCategoryBySubCategoryId(childCategoryId, categories),
    prop(propName),
  )(categories);

export const sortObjectByKeys = (results = {}, predefinedOrder = []) => {
  const orderedEntries = predefinedOrder.reduce((acc, key) => {
    if (results.hasOwnProperty(key)) {
      acc.push([key, results[key]]);
    }
    return acc;
  }, []);

  const remainingEntries = Object.keys(results).reduce((acc, key) => {
    if (!predefinedOrder.includes(key)) {
      acc.push([key, results[key]]);
    }
    return acc;
  }, []);

  const combinedEntries = [...orderedEntries, ...remainingEntries];
  return Object.fromEntries(combinedEntries);
};
